import { ListPlugin } from '@platejs/list-classic/react';
export default ListPlugin.configure({
  options: {
    validLiChildrenTypes: ['shortcode']
  }
});